import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const BackspaceIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 5C7.68524 5 7.38885 5.1482 7.2 5.4L2.7 11.4C2.43333 11.7556 2.43333 12.2444 2.7 12.6L7.2 18.6C7.38886 18.8518 7.68524 19 8 19L21 19C21.5523 19 22 18.5523 22 18L22 6C22 5.44772 21.5523 5 21 5L8 5ZM4.75 12L8.5 7L20 7V17L8.5 17L4.75 12ZM16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L15.4142 12L16.7071 13.2929C17.0976 13.6834 17.0976 14.3166 16.7071 14.7071C16.3166 15.0976 15.6834 15.0976 15.2929 14.7071L14 13.4142L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071C10.9024 14.3166 10.9024 13.6834 11.2929 13.2929L12.5858 12L11.2929 10.7071C10.9024 10.3166 10.9024 9.68342 11.2929 9.2929C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14 10.5858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z"
    fill="currentColor"
  />,
  "BackspaceIcon"
);
